/* Affirm partial-refund calculator (sections/tc-calc-affirm.liquid).
   Pay in 4: equal payments every two weeks, the first charged at checkout.
   A partial refund comes off the UPCOMING payments first, last payment first.
   Anything left over (refund > balance still owed) goes back to the customer's card,
   out of the payments already made (most recent first).
   Payments due on or before the refund date count as already paid. */
(function () {
  var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  var dateFmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  function num(v) { var n = parseFloat(String(v).replace(/[^0-9.\-]/g, '')); return isFinite(n) ? n : 0; }
  function cents(n) { return Math.round(n * 100); }
  function m(c) { return money.format(c / 100); }
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function parse(v) { var p = String(v || '').split('-').map(Number); return p.length === 3 && p[0] ? new Date(p[0], p[1] - 1, p[2]) : null; }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }

  function init(root) {
    var n = parseInt(root.dataset.payments, 10) || 4;
    var gap = parseInt(root.dataset.interval, 10) || 14;
    var q = function (k) { return root.querySelector('[data-tc="' + k + '"]'); };
    var origEl = q('orig'), finalEl = q('final'), startEl = q('start'), refundDateEl = q('refund-date'), errEl = q('error');

    var today = iso(new Date());
    if (!startEl.value) startEl.value = today;
    if (refundDateEl && !refundDateEl.value) refundDateEl.value = today;

    function render() {
      var orig = cents(Math.max(0, num(origEl.value)));
      var fin = cents(Math.max(0, num(finalEl.value)));
      var problem = fin > orig ? 'The order total after the refund can’t be more than the original amount.' : '';
      errEl.hidden = !problem;
      errEl.textContent = problem;

      var start = parse(startEl.value);
      var refundOn = parse(refundDateEl && refundDateEl.value) || new Date();

      // Equal installments in cents; a leftover cent goes on the first payment.
      var base = Math.floor(orig / n), extra = orig - base * n;
      var rows = [];
      for (var i = 0; i < n; i++) {
        var due = start ? new Date(start.getFullYear(), start.getMonth(), start.getDate() + gap * i) : null;
        rows.push({ amt: base + (i === 0 ? extra : 0), due: due, paid: !!due && due <= refundOn, off: 0, back: 0 });
      }
      if (!start) rows[0].paid = true; // first payment is always charged at checkout

      var refund = problem ? 0 : orig - fin;
      var left = refund;
      // 1) upcoming payments, last one first
      for (var j = n - 1; j >= 0 && left > 0; j--) {
        if (rows[j].paid) continue;
        rows[j].off = Math.min(rows[j].amt, left);
        left -= rows[j].off;
      }
      // 2) whatever is left comes back from payments already made, most recent first
      for (var k = n - 1; k >= 0 && left > 0; k--) {
        if (!rows[k].paid) continue;
        rows[k].back = Math.min(rows[k].amt, left);
        left -= rows[k].back;
      }

      var offTotal = 0, backTotal = 0, canceled = 0, reduced = 0, owedBefore = 0;
      rows.forEach(function (r) {
        offTotal += r.off; backTotal += r.back;
        if (!r.paid) owedBefore += r.amt;
        if (r.off && r.off === r.amt) canceled++; else if (r.off) reduced++;
      });

      q('rows').innerHTML = rows.map(function (r, idx) {
        var what, cls = '';
        if (r.paid) {
          what = r.back ? '<strong>' + m(r.back) + ' back to card</strong>' : 'Paid · no change';
          if (r.back) cls = ' is-changed';
        } else if (r.off === r.amt && r.amt > 0) {
          what = '<strong>Canceled</strong>'; cls = ' is-changed is-canceled';
        } else if (r.off) {
          what = '<strong>Reduced by ' + m(r.off) + '</strong>'; cls = ' is-changed';
        } else {
          what = 'No change';
        }
        var pays = r.paid ? r.amt - r.back : r.amt - r.off;
        return '<div class="tc-calc__row' + cls + '" role="row">' +
          '<span role="cell" class="tc-calc__name">Payment ' + (idx + 1) +
            ' <em class="tc-calc__status tc-calc__status--' + (r.paid ? 'paid' : 'due') + '">' + (r.paid ? 'Paid' : 'Upcoming') + '</em></span>' +
          '<span role="cell" data-label="Due">' + (r.due ? dateFmt.format(r.due) : '—') + '</span>' +
          '<span role="cell" data-label="Original">' + m(r.amt) + '</span>' +
          '<span role="cell" data-label="What happens" class="tc-calc__what">' + what + '</span>' +
          '<span role="cell" data-label="Customer pays" class="tc-calc__keep">' + m(pays) + '</span>' +
          '</div>';
      }).join('');

      q('total').textContent = orig ? m(refund) : '—';
      q('off-upcoming').textContent = orig ? m(offTotal) : '—';
      q('to-card').textContent = orig ? m(backTotal) : '—';

      var s;
      if (!orig) s = 'Enter the order amounts to see the new schedule.';
      else if (problem) s = problem;
      else if (!refund) s = 'No refund — the schedule is unchanged.';
      else {
        var out = [];
        var canceledRows = [], reducedRow = null;
        rows.forEach(function (r, idx) {
          if (!r.paid && r.off && r.off === r.amt) canceledRows.push(idx + 1);
          else if (!r.paid && r.off) reducedRow = { n: idx + 1, from: r.amt, to: r.amt - r.off };
        });
        if (canceledRows.length) out.push((canceledRows.length === 1 ? 'Payment ' + canceledRows[0] + ' is' : 'Payments ' + canceledRows.join(' & ').replace(/ & (?=.* & )/g, ', ') + ' are') + ' canceled — the customer is never charged ' + (canceledRows.length === 1 ? 'it' : 'them') + '.');
        if (reducedRow) out.push('Payment ' + reducedRow.n + ' drops from ' + m(reducedRow.from) + ' to ' + m(reducedRow.to) + '.');
        if (backTotal) out.push(m(backTotal) + ' of what they already paid goes back to their card.');
        else out.push('Nothing goes back to their card — the refund fits inside the payments still owed.');
        out.push('They end up paying ' + m(fin) + ' in total.');
        s = out.join(' ');
      }
      q('summary').textContent = s;
    }

    [origEl, finalEl, startEl, refundDateEl].forEach(function (el) { if (el) el.addEventListener('input', render); });
    render();
  }

  function boot() { document.querySelectorAll('[data-tc-calc-affirm]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
